import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const storyApi = createApi({
  reducerPath: "storyApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Story"], // Changed from Banner to Story so caching is relevant
  endpoints: (builder) => ({
    // GET all stories (paginated)
    getStories: builder.query({
      query: ({ page = 1, pageSize = 10, search = "" }) =>
        `/listener/stories?page=${page}&pageSize=${pageSize}&search=${search}`,
      providesTags: ["Story"],
    }),

    // DELETE a story
    deleteStory: builder.mutation({
      query: (id) => ({
        url: `/listener/story/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Story"],
    }),

    // POST add story (multipart/form-data)
    addStory: builder.mutation({
      query: (formData) => ({
        url: `/listener/story`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Story"],
    }),

    // POST approve story
    approveStory: builder.mutation({
      query: (listenerId) => ({
        url: `/listener/approve-story`,
        method: "POST",
        body: { listenerId },
      }),
      invalidatesTags: ["Story"],
    }),
  }),
});

export const {
  useGetStoriesQuery,
  useDeleteStoryMutation,
  useAddStoryMutation,
  useApproveStoryMutation,
} = storyApi;
